<template>
  <div class="animated fadeIn wilayah-page">
    <b-row class="wilayah-row">
      <b-col lg="3" class="mb-3 mb-lg-0">
        <b-card no-body class="h-100 wilayah-menu-card">
          <b-list-group flush>
            <b-list-group-item
              v-for="menu in menus"
              :key="menu.key"
              button
              :active="activeType === menu.key"
              class="wilayah-menu-item"
              @click="selectMenu(menu.key)"
            >
              {{ menu.label }}
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>

      <b-col lg="9">
        <b-card class="wilayah-content-card">
          <template v-slot:header>
            <h5 class="mb-0">{{ pageTitle }}</h5>
          </template>

          <b-row v-if="activeType !== 'province'" class="mb-3">
            <b-col md="4">
              <b-form-group label="Provinsi" class="mb-2 mb-md-0">
                <multiselect
                  v-model="filters.province"
                  :options="provinces"
                  label="name"
                  track-by="id"
                  placeholder="Pilih provinsi"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  @input="onProvinceChange"
                />
              </b-form-group>
            </b-col>
            <b-col v-if="showCityFilter" md="4">
              <b-form-group label="Kota/Kabupaten" class="mb-2 mb-md-0">
                <multiselect
                  v-model="filters.city"
                  :options="cities"
                  :disabled="!filters.province"
                  label="name"
                  track-by="id"
                  placeholder="Pilih kota/kabupaten"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  @input="onCityChange"
                />
              </b-form-group>
            </b-col>
            <b-col v-if="showDistrictFilter" md="4">
              <b-form-group label="Kecamatan" class="mb-0">
                <multiselect
                  v-model="filters.district"
                  :options="districts"
                  :disabled="!filters.city"
                  label="name"
                  track-by="id"
                  placeholder="Pilih kecamatan"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  @input="onDistrictChange"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <div class="d-flex flex-column flex-md-row justify-content-between mb-3">
            <b-input-group class="wilayah-search mb-3 mb-md-0">
              <b-input-group-prepend is-text>
                <i class="fa fa-search"></i>
              </b-input-group-prepend>
              <b-form-input
                v-model="keyword"
                type="search"
                :placeholder="searchPlaceholder"
              />
            </b-input-group>

            <b-button
              v-if="activeType !== 'province'"
              class="ml-md-3"
              variant="pgiBtn"
              :disabled="!isFilterComplete"
              @click="openCreateModal"
            >
              <i class="fa fa-plus mr-1"></i>
              Tambah {{ activeMenu.label }}
            </b-button>
          </div>

          <b-table
            bordered
            hover
            show-empty
            sticky-header="420px"
            :items="filteredItems"
            :fields="tableFields"
            :busy="isBusy"
            class="mb-0"
          >
            <template v-slot:table-busy>
              <div class="text-center my-3">
                <b-spinner small />
                <span class="ml-2">Memuat data...</span>
              </div>
            </template>
            <template v-slot:empty>
              {{ emptyMessage }}
            </template>
            <template v-slot:cell(no)="row">
              {{ row.index + 1 }}
            </template>
            <template v-slot:cell(action)="row">
              <b-button
                v-if="activeType !== 'province'"
                size="sm"
                class="table-button edit"
                title="Edit"
                @click="openEditModal(row.item)"
              >
                <i class="fa fa-pencil-square-o"></i>
              </b-button>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      id="modal-wilayah"
      :title="modalTitle"
      ok-title="Simpan"
      cancel-title="Batal"
      @ok="saveForm"
    >
      <b-form-group :label="`Nama ${activeMenu.label}`">
        <b-form-input
          v-model.trim="form.name"
          :state="formSubmitted ? Boolean(form.name) : null"
          :placeholder="`Masukkan nama ${activeMenu.label.toLowerCase()}`"
          maxlength="100"
          required
        />
        <b-form-invalid-feedback>
          Nama {{ activeMenu.label }} wajib diisi.
        </b-form-invalid-feedback>
      </b-form-group>
    </b-modal>

    <ModalConfirm
      id="modal-confirm-create-wilayah"
      :title="`Konfirmasi Tambah ${activeMenu.label}`"
      :desc="`Apakah anda yakin menambah ${activeMenu.label} ini?`"
      :isSubmitting="isSubmitting"
      @submit="submitCreate"
    />
    <ModalConfirm
      id="modal-confirm-edit-wilayah"
      :title="`Konfirmasi Edit ${activeMenu.label}`"
      :desc="`Apakah anda yakin mengubah ${activeMenu.label} ini?`"
      :isSubmitting="isSubmitting"
      @submit="submitEdit"
    />
  </div>
</template>

<script>
export default {
  name: "MasterWilayah",
  data() {
    return {
      activeType: "province",
      keyword: "",
      isBusy: false,
      isSubmitting: false,
      formSubmitted: false,
      editId: null,
      form: {
        name: "",
      },
      menus: [
        { key: "province", label: "Provinsi" },
        { key: "city", label: "Kota/Kabupaten" },
        { key: "district", label: "Kecamatan" },
        { key: "village", label: "Kelurahan/Desa" },
      ],
      filters: {
        province: null,
        city: null,
        district: null,
      },
      provinces: [],
      cities: [],
      districts: [],
      items: [],
    };
  },
  created() {
    this.loadProvinces(true);
  },
  computed: {
    activeMenu() {
      return this.menus.find((menu) => menu.key === this.activeType);
    },
    pageTitle() {
      return `Daftar ${this.activeMenu.label}`;
    },
    searchPlaceholder() {
      return `Cari ${this.activeMenu.label.toLowerCase()}...`;
    },
    showCityFilter() {
      return ["district", "village"].includes(this.activeType);
    },
    showDistrictFilter() {
      return this.activeType === "village";
    },
    isFilterComplete() {
      if (this.activeType === "province") return true;
      if (this.activeType === "city") return Boolean(this.filters.province);
      if (this.activeType === "district") return Boolean(this.filters.city);
      return Boolean(this.filters.district);
    },
    emptyMessage() {
      if (!this.isFilterComplete) {
        return "Pilih wilayah induk terlebih dahulu.";
      }
      return `Tidak ada data ${this.activeMenu.label}.`;
    },
    tableFields() {
      const fields = [
        { key: "no", label: "No", thStyle: { width: "70px" } },
        { key: "name", label: `Nama ${this.activeMenu.label}` },
      ];
      if (this.activeType !== "province") {
        fields.push({ key: "action", label: "Aksi", thStyle: { width: "90px" } });
      }
      return fields;
    },
    filteredItems() {
      const keyword = this.keyword.toLowerCase();
      return this.items.filter((item) => item.name.toLowerCase().includes(keyword));
    },
    modalTitle() {
      return `${this.editId ? "Edit" : "Tambah"} ${this.activeMenu.label}`;
    },
  },
  methods: {
    selectMenu(type) {
      this.activeType = type;
      this.keyword = "";
      this.loadActiveItems();
    },
    requestItems(url, params, target, showAsItems) {
      this.isBusy = true;
      return this.$axios
        .get(url, { params })
        .then((response) => {
          this[target] = response.data || [];
          if (showAsItems) this.items = this[target];
        })
        .catch((error) => {
          this[target] = [];
          if (showAsItems) this.items = [];
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.isBusy = false;
        });
    },
    loadProvinces(showAsItems = false) {
      return this.requestItems(
        "master/wilayah/provinsi",
        {},
        "provinces",
        showAsItems
      );
    },
    loadCities(showAsItems = false) {
      if (!this.filters.province) return Promise.resolve();
      return this.requestItems(
        "master/wilayah/kabupaten-kota",
        { provinsiId: this.filters.province.id },
        "cities",
        showAsItems
      );
    },
    loadDistricts(showAsItems = false) {
      if (!this.filters.city) return Promise.resolve();
      return this.requestItems(
        "master/wilayah/kecamatan",
        { kabupatenKotaId: this.filters.city.id },
        "districts",
        showAsItems
      );
    },
    loadVillages() {
      if (!this.filters.district) return Promise.resolve();
      return this.requestItems(
        "master/wilayah/kelurahan-desa",
        { kecamatanId: this.filters.district.id },
        "items",
        false
      );
    },
    loadActiveItems() {
      this.items = [];
      if (this.activeType === "province") {
        this.items = this.provinces;
      } else if (this.activeType === "city") {
        this.loadCities(true);
      } else if (this.activeType === "district") {
        this.loadDistricts(true);
      } else {
        this.loadVillages();
      }
    },
    onProvinceChange() {
      this.filters.city = null;
      this.filters.district = null;
      this.cities = [];
      this.districts = [];
      this.items = [];
      if (this.filters.province) {
        this.loadCities(this.activeType === "city");
      }
    },
    onCityChange() {
      this.filters.district = null;
      this.districts = [];
      this.items = [];
      if (this.filters.city) {
        this.loadDistricts(this.activeType === "district");
      }
    },
    onDistrictChange() {
      this.items = [];
      if (this.filters.district) this.loadVillages();
    },
    openCreateModal() {
      if (this.activeType === "province") return;
      this.editId = null;
      this.formSubmitted = false;
      this.form = {
        name: "",
      };
      this.$bvModal.show("modal-wilayah");
    },
    openEditModal(item) {
      this.editId = item.id;
      this.formSubmitted = false;
      this.form = {
        name: item.name,
      };
      this.$bvModal.show("modal-wilayah");
    },
    saveForm(event) {
      this.formSubmitted = true;
      if (!this.form.name) {
        event.preventDefault();
        this.$helper.toastErr(this, `Nama ${this.activeMenu.label} wajib diisi.`);
        return;
      }

      event.preventDefault();
      if (!this.editId) {
        this.$bvModal.show("modal-confirm-create-wilayah");
        return;
      }

      this.$bvModal.show("modal-confirm-edit-wilayah");
    },
    getCreateRequest() {
      if (this.activeType === "city") {
        return {
          url: "master/wilayah/kabupaten-kota",
          params: {
            provinsiId: this.filters.province.id,
            name: this.form.name,
          },
        };
      }

      if (this.activeType === "district") {
        return {
          url: "master/wilayah/kecamatan",
          params: {
            kabupatenKotaId: this.filters.city.id,
            name: this.form.name,
          },
        };
      }

      return {
        url: "master/wilayah/kelurahan-desa",
        params: {
          kecamatanId: this.filters.district.id,
          name: this.form.name,
        },
      };
    },
    submitCreate() {
      const request = this.getCreateRequest();
      this.isSubmitting = true;

      this.$axios
        .post(request.url, null, { params: request.params })
        .then(() => {
          this.$helper.toastSucc(this, `${this.activeMenu.label} berhasil ditambahkan.`);
          this.$bvModal.hide("modal-confirm-create-wilayah");
          this.$bvModal.hide("modal-wilayah");
          this.form.name = "";
          this.formSubmitted = false;
          this.loadActiveItems();
        })
        .catch((error) => this.$helper.parseError(this, error))
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    getEditRequest() {
      const request = this.getCreateRequest();
      return {
        url: request.url,
        params: {
          id: this.editId,
          ...request.params,
        },
      };
    },
    submitEdit() {
      const request = this.getEditRequest();
      this.isSubmitting = true;

      this.$axios
        .put(request.url, null, { params: request.params })
        .then(() => {
          this.$helper.toastSucc(this, `${this.activeMenu.label} berhasil diubah.`);
          this.$bvModal.hide("modal-confirm-edit-wilayah");
          this.$bvModal.hide("modal-wilayah");
          this.form.name = "";
          this.formSubmitted = false;
          this.editId = null;
          this.loadActiveItems();
        })
        .catch((error) => this.$helper.parseError(this, error))
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
};
</script>

<style scoped>
.wilayah-menu-card,
.wilayah-content-card {
  height: 100%;
  min-height: 520px;
}

.wilayah-row > [class*="col-"] {
  display: flex;
  flex-direction: column;
}

.wilayah-row .card {
  flex: 1;
}

.wilayah-menu-item {
  padding: 18px 20px;
  font-weight: 600;
  border-left: 4px solid transparent;
}

.wilayah-menu-item.active {
  color: #fff;
  background-color: #1e73be;
  border-color: #1e73be;
}

.wilayah-search {
  width: 340px;
}

@media (max-width: 767.98px) {
  .wilayah-menu-card,
  .wilayah-content-card {
    min-height: auto;
  }

  .wilayah-search {
    width: 100%;
  }
}
</style>
